export default __webpack_public_path__ + "static/media/largeScreen.81820234.png";